module.exports = __webpack_public_path__ + "static/OrbitFox-1c945c3280829b2283ec4920c27fce8d.svg";